<template lang="pug">
.main
  v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
    v-form(ref="KgtunkuForm")

      h4.mt-4 Kg Tunku Digital Micro-Entrepreneurs Initiative
      br
      v-text-field.p1(v-model="form.phoneEmail" @keyup.enter="validatePenang" :rules="rules.phoneEmail" outlined hide-details dense solo flat background-color="basic200"   height="40")
        template(v-slot:label)
          .p1.basic600--text Phone number or Email address
      v-text-field.mt-2(color="primary" v-model="project.postcode" type="text" dense solo flat background-color="basic200" outlined height="40" @keyup.enter="validatePenang" :rules="rules.postcode")
        template(v-slot:label)
          .p1.basic600--text Postcode number
      v-btn.button-AA-medium.mb-4.px-4.elevation-0(color="info500" block dark depressed @click="validatekgtunku" :loading="loading") Continue
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ValidateProjectKgtunku',
  data: () => ({
    loading: false,
    projectId: null,
    form: {
      phoneEmail: '',
    },
    project: {
      id: null,
      postcode: ''
    },
    rules: {
      phoneEmail: [
        v => !!v || 'Phone number or e-mail address is required'
      ],
      postcode: [
        v => !!v || 'Postcode is required'
      ]
    }
  }),
  mounted () {
    this.project.id = this.$route.query.project
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    validatekgtunku() {
      if (!this.$refs.KgtunkuForm.validate()) {
        return
      }

      if (!['46000', '46050', '46100', '46150', '46200', '46300', '46350', '46400', '46506', '46547', '46549', '46551', '46564', '46582', '46598', '46662', '46667', '46668', '46672', '46675', '46700', '46710', '46720', '46730', '46740', '46750', '46760', '46770', '46780', '46781', '46782', '46783', '46784', '46785', '46786', '46787', '46788', '46789', '46790', '46791', '46792', '46793', '46794', '46795', '46796', '46797', '46798', '46799', '46800', '46801', '46802', '46803', '46804', '46805', '46806', '46860', '46870', '46960', '46962', '46964', '46966', '46968', '46970', '46972', '46974', '46976', '46978', '47300', '47301', '47307', '47308', '47400', '47410', '47500', '47800', '47810', '47820', '47830'].includes(this.project.postcode)) {
        this.showMessage(['error', this.$t('error_message.sorry_not_eligible')])
        return
      }

      this.loading = true
      this.$axios.get(`/sponsors/${this.project.id}/`)
        .then(resp => {
          if (resp.full) {
            this.loading = false
            this.showMessage(['error', this.$t('error_message.sorry_no_open_seats')])
          } else {
            this.$emit('verified', this.form.phoneEmail)
          }
        })
        .catch(() => {
          this.loading = false
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>